<template>
<v-dialog
  :value="openModal"
  persistent
  @close="closeModal"
  max-width="800"
  :content-class="'ModalCreateNews'"
>
  <v-card class="ModalCreateNews__card d-flex flex-column px-6 py-4">
    <div class="ModalCreateNews__close d-flex justify-end">
      <v-btn
        small
        @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalCreateNews__title">
      <span v-if="updateItem.id" >Редактировать модальное окно</span>
      <span v-else>Добавить модальное окно</span>

    </div>
    <div class="ModalCreateNews__body d-flex flex-column gap-4">
      <div class="">
        <p>Введите название</p>
        <v-textarea
          v-model="fieldName"
          :placeholder="'Введите название'"
          :value="fieldName"
          :dense="true"
          :outlined="true"
          :hide-details="true"
        />
        <div class="text-error pt-1">
          {{getFieldError('name')}}
        </div>
      </div>
      <div class="d-flex gap-4 ">
        <div class="w-100">
          <p>Текст модального окна</p>
          <v-textarea
            v-model="fieldBody"
            :class="'full'"
            :placeholder="'Добавьте текст'"
            :value="fieldBody"
            :dense="true"
            :outlined="true"
            :hide-details="true"
          />
          <div class="text-error pt-1">
            {{getFieldError('body')}}
          </div>
        </div>
        <div class="w-100">
          <upload-box
            v-if="!fieldImage"
            :styles="styleUploadBox"
            :accept-file="['jpg, png']"
            :loading="loadingImage"
            :is-file-uploaded="fieldImage"
            :show-error="getFieldError('image')"
            @upload="uploadImage"
          />

          <div v-if="fieldImage && !loadingImage" class="image-field">
            <div :class="['relative',{'error-image': getFieldError('image') }]">
              <v-img

                :max-width="368"
                :max-height="180"
                :contain="true"
                :src="fieldImageBase64"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      size="32"
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <span style="position: absolute; top: 0; right: 15px">
                <v-btn icon color="error"  @click="deleteImage">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </span>
            </div>
          </div>
          <div class="text-error pt-1" v-if="getFieldError('image') || imageError">
            {{getFieldError('image') || imageError}}
          </div>
        </div>
      </div>
    </div>
    <div class="ModalCreateNews__btn-group">
      <div>
        <v-btn
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="cancel"

        >
          Отменить
        </v-btn>
      </div>
      <div v-if="!updateItem.id">
        <v-btn
          class="_w-100"
          color="primary"
          @click="createNews(false)"
        >
          Добавить
        </v-btn>
      </div>
      <div v-if="updateItem.id">
        <v-btn
          class="_w-100"
          color="primary"
          @click="createNews(true)"
        >
          Обновить
        </v-btn>
      </div>
    </div>
  </v-card>
</v-dialog>
</template>

<script>

import UploadBox from '@/components/candidates/profile/dossier/UploadBox.vue';
import { minLength, required } from 'vuelidate/lib/validators';
import Vue from 'vue';
import { ImageValidators as imageValidators } from '@/common/validationHelpers';

/**
 * Компонент: ModalCreateNews
 * Описание:
 */
export default {
  name: 'ModalCreateNews',

  components: { UploadBox },

  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    uploadFile: {
      type: Object,
      default: () => ({
        isUpload: false,
        image: null,
      }),
    },
    updateItem: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeModal', 'upload:file', 'createNews', 'updateNews'],

  validations() {
    const rules = {
      name: {
        required,
        minLength: minLength(5),
      },
      body: {
        required,
        minLength: minLength(5),
      },
      image: {
        required,
        maxSize: imageValidators.maxSize(5),
        format: imageValidators.format(['jpg', 'png', 'jpeg', 'webp']),
      }
    };
    return {
      formValues: rules
    };
  },

  data() {
    const fieldName = '';
    const fieldBody = '';
    const fieldImage = null;
    const fieldImageBase64 = null;
    const loadingImage = false;
    const styleUploadBox = {
      height: '188px',
      margin: 0
    };
    const imageError = null;
    const formValues = {};

    return {
      fieldBody,
      fieldName,
      fieldImage,
      styleUploadBox,
      loadingImage,
      fieldImageBase64,
      imageError,
      formValues,
    };
  },

  computed: {},

  watch: {
    fieldName(val) {
      this.$set(this.formValues, 'name', val);
    },
    fieldBody(val) {
      this.$set(this.formValues, 'body', val);
    },
    fieldImage(val) {
      this.$set(this.formValues, 'image', val);
    },
    updateItem(val) {
      if (val && val.id) {
        this.fillField();
      }
    }
  },

  created() {
  },

  mounted() {
    if (this.updateItem && this.updateItem.id) {
      this.fillField();
    }
  },

  beforeDestroy() {
  },

  methods: {
    clickSubmit(file) {
      this.$emit('upload:file', file);
    },
    okClicked() {

    },
    cancel() {
      this.closeModal();
      this.fieldName = '';
      this.fieldBody = '';
      this.fieldImage = null;
      this.fieldImageBase64 = null;
    },
    showError(error) {
      this.imageError = error;
    },
    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
    },
    // renderImage
    async renderImageBase64(image) {
      if (!image || !image.type.match('image.*')) {
        this.showError('Формат изображения неверный');
        return null;
      }
      try {
        return await this.readFileAsDataURL(image);
      } catch (error) {
        this.showError(`Ошибка чтения файла ${error}`);
        return null;
      }
    },
    async uploadImage(file) {
      this.loadingImage = true;
      const base64Image = await this.readFileAsDataURL(file);
      if (base64Image) {
        this.fieldImage = file;
        this.fieldImageBase64 = base64Image;
      }

      this.loadingImage = false;
    },
    deleteImage() {
      this.fieldImageBase64 = null;
      this.fieldImage = null;
    },
    validateForm() {
      if (this.$v.formValues.name) {
        this.$v.formValues.name.$touch();
      }
      if (this.$v.formValues.body) {
        this.$v.formValues.body.$touch();
      }
      if (this.$v.formValues.image) {
        this.$v.formValues.image.$touch();
      }
    },
    createNews(update = false) {
      const data = {
        fieldName: this.fieldName,
        fieldBody: this.fieldBody,
        fieldImage: this.fieldImage,
      };
      this.validateForm();
      if (this.$v.$invalid) {
        Vue.prototype.$toast.error('Форма заполнена некорректно', '', { position: 'bottomCenter' });
        return;
      }
      if (update) {
         data.id = this.updateItem.id;
         this.$emit('updateNews', data);
         this.closeModal();
      } else {
        this.$emit('createNews', data);
        this.closeModal();
      }
    },
    getFieldError(fieldName) {
      const validator = this.$v.formValues[fieldName];
      if (!validator || !validator.$error) return '';
      if (validator.required === false) {
        return 'Это поле обязательно';
      }
      if (validator.minLength === false) {
        return 'Минимум 5 символов';
      }
      if (validator.maxSize === false) {
        return 'Макс. размер  5 МБ';
      }
      if (validator.format === false) {
        return 'Не допустимый формат';
      }
      return 'Ошибка валидации';
    },
    touchField(field) {
      const fieldName = `field_${field.field}`;
      if (this.$v.formValues[fieldName]) {
        this.$v.formValues[fieldName].$touch();
      }
    },
    async urlToFile(imageUrl, fileName = null) {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error(`Ошибка загрузки: ${response.status}`);
        }
        const blob = await response.blob();
        let finalFileName = fileName;
        if (!finalFileName) {
          const urlObj = new URL(imageUrl);
          const pathParts = urlObj.pathname.split('/');
          finalFileName = pathParts[pathParts.length - 1] || 'image';
        }

        let mimeType = blob.type;

        if (mimeType === 'binary/octet-stream'
          || mimeType === 'application/octet-stream'
          || !mimeType
          || mimeType === '') {
          let extension = '';

          if (finalFileName.includes('.')) {
            extension = finalFileName.split('.').pop().toLowerCase();
          } else {
            const urlExtension = imageUrl.split('.').pop().split('?')[0].toLowerCase();
            extension = urlExtension;
            finalFileName = `image.${extension}`;
          }
          const mimeMap = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            webp: 'image/webp',
            svg: 'image/svg+xml',
            bmp: 'image/bmp',
            ico: 'image/x-icon',
            tiff: 'image/tiff',
            tif: 'image/tiff',
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/msword',
          };

          mimeType = mimeMap[extension] || 'image/jpeg';
        }

        const file = new File([blob], finalFileName, {
          type: mimeType,
          lastModified: Date.now()
        });
        return file;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fillField() {
      if (this.updateItem && this.updateItem.id) {
        this.fieldName = this.updateItem.title;
        this.fieldBody = this.updateItem.text;
        if (this.updateItem?.image_url) {
          const file = await this.urlToFile(this.updateItem.image_url);
          if (file) {
            this.fieldImage = file;
            this.fieldImageBase64 = this.updateItem.image_url;
          }
        }
      }
    },
    closeModal() {
      this.$emit('closeModal');
      this.fieldName = '';
      this.fieldBody = '';
      this.fieldImage = null;
      this.fieldImageBase64 = '';
    }

  },
};
</script>

<style scoped lang="scss">
.ModalCreateNews {
  &__card {
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close {
    & > button {
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
  }

  &__btn-group {
    display: flex;
    justify-content: flex-end;
  }

  &__body{
    & .v-textarea {
      ::v-deep .v-input__control{
        border-radius: 8px;
        border: 1px solid var(--color-grey-200);
      }
      &.full::v-deep textarea{
        height: 140px;
        border-radius: 20px;
        padding-left: 8px;
      }
      ::v-deep textarea{
        height: 40px;
        border-radius: 20px;
        padding-left: 8px;
      }
    }
    & .image-field .error-image{
      padding: 4px;
      border-radius: 10px;
      outline: 2px dashed var(--v-error-base);
      color:  var(--v-error-base);
    }
  }

}
</style>
